import type { ComponentChildren, ComponentProps } from 'preact';
import styles from './Card.module.css';

export interface CardProps extends Omit<
  ComponentProps<'div'>,
  'children' | 'className' | 'ref'
> {
  children: ComponentChildren;
}

export function Card({ children, ...props }: CardProps) {
  return (
    <div {...props} className={styles.card}>
      {children}
    </div>
  );
}
